<template>
  <div class="common-bg">
    <div class="tool-drawer-header">
      <a @click="clickBack">
        <a-icon type="left" />
      </a>
      <div class="title">{{ $t('edit.hpInfo.scenePH') }}</div>
    </div>

    <div class="tool-drawer-content">
      <IconSelect :currentIcon="sceneObj.icon_url" @onSelectIcon="onSelectIcon" :type="2"></IconSelect>
      <!-- 標題 -->
      <div class="tit-box">
        <div class="tit-desc">
          <span>{{ $t('edit.title') }}</span>
          <a-checkbox :checked="sceneObj.is_show_title === 1" @change="isShowTitle">{{ $t('edit.hpInfo.showTitle')
          }}</a-checkbox>
        </div>
        <a-input :placeholder="$t('edit.hpInfo.inputTitle')" v-model="sceneObj.title" @change="titleChange" />
      </div>

      <div style="margin:20px;">
        <div style="margin-bottom:10px;">{{ $t('edit.editMessage.selectScene') }}</div>
        <div class="list-container">
          <ImgItem :itemObj="value" v-for="(value, k) in sceneList" :key="k" :selected="selectedScene"
            @click.native="selectScene(value)"></ImgItem>
        </div>
      </div>
    </div>

    <div class="tool-drawer-btns">
      <DoubleBtn @onClickSave="onClickSave" @onClickCancel="clickDelete"></DoubleBtn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ImgItem from "./ImgItem.vue";
import IconSelect from "./IconSelect.vue";
import { v4 as uuidv4 } from "uuid";
import DoubleBtn from "../DoubbleBtn";

export default {
  components: { ImgItem, IconSelect, DoubleBtn },
  props: {
    defaultValue: {
      type: Object,
    },
  },
  data() {
    return {
      selectedScene: [],
      sceneList: [],
      // selectIcon: "",
      // title: "",
      sceneObj: {
        type: "scene",
        hotspot_id: "hotspot_" + uuidv4(),
        icon_url: "",
        is_dynamic: 1,
        ath: "",
        atv: "",
        hath: "0",
        vatv: "0",
        title: "",
        is_show_title: 1,
        content: "",
        thumb_path: ""
      },
    };
  },
  watch: {
    defaultValue: {
      handler: function (value) {
        if (value) {
          // this.title = value.title;
          // this.selectIcon = value.icon_url;
          this.selectedScene[0] = this.vrbase.scenes[value.content];
          this.sceneObj = value;
        }
      },
      immediate: true,
      deep: true,
    },
    newSceneObj: {
      handler: function (val, oldVal) {
        if (val.ath == "" && val.atv == "") {
          const vh = getSceneViewAt();
          this.sceneObj.ath = vh.hlookat;
          this.sceneObj.atv = vh.vlookat;
        }
        this.$emit("change", this.sceneObj, oldVal);
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["vrbase", "currentScenesId"]),
    newSceneObj() {
      return this.$deepClone(this.sceneObj);
    },
  },
  created() {
    this.sceneList = this.vrbase.scenes;
    console.log('this.sceneList:',this.sceneList);
  },
  mounted() {
    this.$bus.$on("updateHotspot", (e) => {
      if (e.hotspot_id == this.sceneObj.hotspot_id) {
        this.sceneObj.ath = e.ath;
        this.sceneObj.atv = e.atv;
      }
    });
  },
  methods: {
    onSelectIcon(item) {
      this.sceneObj.icon_url = item.icon_url;
      this.sceneObj.thumb_path = item.thumb_path;
      this.sceneObj.is_dynamic = item.is_dynamic;
    },
    selectScene(item) {
      this.selectedScene = [item];
      this.sceneObj.content = item.scene_id;
      this.sceneObj.title = item.scene_title;
    },
    isShowTitle(e) {
      this.sceneObj.is_show_title = e.target.checked ? 1 : 0;
    },
    titleChange(e) {
      this.sceneObj.title = e.target.value;
    },
    clickBack() {
      this.$emit("clickBack", this.sceneObj);
    },
    clickDelete() {
      this.$emit("clickDelete", this.sceneObj);
    },
    onClickSave() {
      if (!this.sceneObj.icon_url) {
        this.$message.error(this.$t('edit.hpInfo.hpIcon'));
        return;
      }
      if (!this.sceneObj.title) {
        this.$message.error(this.$t('edit.hpInfo.inputTitle'));
        return;
      }
      if (!this.sceneObj.content) {
        this.$message.error(this.$t('edit.editMessage.sceneConfirm'));
        return;
      }
      this.$emit("saveDataToStore", {
        key: this.sceneObj.hotspot_id,
        data: this.sceneObj,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.list-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  justify-items: center;
  grid-gap: 5px;
}
</style>